'use client'
import { useMenuCopy } from '@/context/site-chrome-copy'
import { anchorClass } from './channel'

const CreateContent = () => {
    const copy = useMenuCopy()

    return (
        <div className="flex h-full w-full items-center justify-center">
            <a href="/upload" className={anchorClass}>
                {copy.upload}
            </a>
            <div className="h-8 w-0 border-l-2 border-white opacity-30" />
            <a href="/create" className={anchorClass}>
                {copy.create}
            </a>
        </div>
    )
}

export default CreateContent
